export default __webpack_public_path__ + "static/media/Sort.3bcc9776.svg";